// extracted by mini-css-extract-plugin
export default {"promobanner":"promotionBanner-module--promobanner--jDE4i"};